"use client";
import PropTypes from "prop-types";

import Wrapper from "components/listing-detail/wrapper";

const ListingDetailScreen = ({ pageResponse }) => {
  return (
    <>
      <div id="content-wrapper">
        <Wrapper pageResponse={pageResponse} />
      </div>
    </>
  );
};

ListingDetailScreen.propTypes = {
  pageResponse: PropTypes.object,
};

export default ListingDetailScreen;
